<template>
<div>
    <h2>
    Pobierz pliki
    </h2>
    
<h3>Do wersji 5.x</h3>
<p>
    Aplikacja znajduje się na sterowniku. Dostęp przez przeglądarkę.
</p>
<ul>       
    <li>Instrukcja użytkownika (PDF): <a href="/ldpv5/Instrukcjav5.pdf">InstrukcjaV5.pdf</a></li>        
    <li>Aplikacja do wyszukania sterownika: <a href="http://ldpv5.palabras.pl">http://ldpv5.palabras.pl</a></li>        
    <li>Aplikacja pomocnicza: <a href="http://ldp.palabras.pl">http://ldp.palabras.pl</a></li>        
</ul>


<h3>Do wersji 4.x</h3>
<p>
    </p><ul>       
        <li>Windows (exe, 4.2.0, 24.01.2022) <a :href="'../content/LedDimmerProV4-4.2.0 Setup.exe'">Pobierz</a></li>
        <li>Sterowniki USB Windows: <a href="../content/CH341SER.EXE">CH341SER.EXE</a></li>
        <li>Instrukcja użytkownika (PDF): <a href="../content/Instrukcja4.pdf">Instrukcja4.pdf</a></li>        
    </ul>

<h3>Do wersji 2.0-3.x</h3>
<p>
    </p><ul>
        <li>Aplikacja Windows exe: <a href="../leddimmer/setup.exe">setup.exe</a></li>
        <li>Sterowniki USB Windows: <a href="../content/CH340G.exe">CH340G.exe</a>
        </li><li>Instrukcja użytkownika (PDF): <a href="../content/Instrukcja.pdf">Instrukcja.pdf</a></li>
    </ul>


<h3>Do wersji 1.0-1.6</h3>
<p>
    </p><ul>
        <li>Aplikacja Windows exe: <a href="../leddimmer/setup.exe">setup.exe</a></li>
        <li>Instrukcja użytkownika (PDF): <a href="../content/Instrukcja.pdf">Instrukcja.pdf</a></li>
        <li>Sterowniki USB Windows (8/8.1 32 bitowe): <a href="../content/PL2303_Windows8_32bit_Installer.exe">PL2303_Windows8_32bit_Installer.exe</a></li>
        <li>Sterowniki USB Windows (inne 32 bitowe): <a href="../content/PL2303_32bit_Installer.exe">PL2303_32bit_Installer.exe</a></li>
        <li>Sterowniki USB Windows (inne 64 bitowe): <a href="../content/PL2303_64bit_Installer.exe">PL2303_64bit_Installer.exe</a></li>
    </ul>

</div>
</template>

<script>

export default {
  name: 'download',
  components: {      
  },  
  methods: {
      $tr: function(x) { return x; }
  },
  data: function() {
      return {
          
      }
  }
}
</script>
